'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _assertThisInitialized = require('@babel/runtime/helpers/assertThisInitialized');
var _inheritsLoose = require('@babel/runtime/helpers/inheritsLoose');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var formik = require('formik');
var bumbag = require('bumbag');
var validate = require('@medipass/utils/validate-form');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var validate__default = /*#__PURE__*/_interopDefaultLegacy(validate);

// @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
var isLengthGreaterThanOrEqualTo6 = function isLengthGreaterThanOrEqualTo6(value) {
  return validate.isLengthGreaterThanOrEqualTo(6)(value);
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.


var isLengthLessThanOrEqualTo10 = function isLengthLessThanOrEqualTo10(value) {
  return validate.isLengthLessThanOrEqualTo(10)(value);
};

var MedicareBankDetails = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose__default["default"](MedicareBankDetails, _React$Component);

  function MedicareBankDetails() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "state", {
      bankDetailsVisibility: 'false'
    });

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "handleToggle", function (visibility) {
      _this.setState({
        bankDetailsVisibility: visibility
      });
    });

    return _this;
  }

  var _proto = MedicareBankDetails.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var bankDetailsVisibility = this.state.bankDetailsVisibility;
    return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(bumbag.RadioGroupField, {
      orientation: "horizontal",
      label: "Receive benefit into the bank account on file with Medicare?",
      name: "bankAccountCheckBox" // @ts-expect-error TS(2339): Property 'value' does not exist on type 'EventTarg... Remove this comment to see the full error message
      ,
      onChange: function onChange(e) {
        return _this2.handleToggle(e.target.value);
      },
      value: bankDetailsVisibility,
      options: [{
        label: 'Yes',
        value: 'false'
      }, {
        label: 'No',
        value: 'true'
      }]
    }), bankDetailsVisibility === 'true' &&
    /*#__PURE__*/
    // @ts-expect-error TS(2322): Type '{ children: Element[]; backgroundColor: "whi... Remove this comment to see the full error message
    React__default["default"].createElement(bumbag.Box, {
      backgroundColor: "white700",
      isFullWidth: true,
      marginTop: "major-2",
      padding: "major-2"
    }, /*#__PURE__*/React__default["default"].createElement("h2", {
      className: "mb-5 mt-2 text-lg font-bold"
    }, "Specify a temporary bank account"), /*#__PURE__*/React__default["default"].createElement(bumbag.FieldStack, null, /*#__PURE__*/React__default["default"].createElement(formik.Field, {
      component: bumbag.InputField.Formik,
      name: "bankAccountName",
      label: "Bank account name",
      autoComplete: "given-name",
      validate: validate__default["default"](validate.isRequired)
    }), /*#__PURE__*/React__default["default"].createElement(formik.Field, {
      component: bumbag.InputField.Formik,
      name: "bankAccountNumber",
      label: "Bank account number",
      validate: validate__default["default"](validate.isRequired, validate.isNumber, isLengthGreaterThanOrEqualTo6, isLengthLessThanOrEqualTo10)
    }), /*#__PURE__*/React__default["default"].createElement(formik.Field, {
      component: bumbag.InputField.Formik,
      name: "bankBSB",
      label: "Bank BSB",
      validate: validate__default["default"](validate.isRequired, validate.isNumber, isLengthGreaterThanOrEqualTo6, isLengthLessThanOrEqualTo10)
    }))));
  };

  return MedicareBankDetails;
}(React__default["default"].Component);

exports.MedicareBankDetails = MedicareBankDetails;
exports["default"] = MedicareBankDetails;
